import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { CONTAINER_TYPES } from 'web-interactives-data/constants/ContainerConstants';
import { openEmbedModal } from 'web-interactives-dashboard-ui/actions/ModalActions';
import { getIsPublished } from 'web-interactives-dashboard-ui/utils/webInteractiveStateUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EmbedMenuAction = ({
  interactiveId,
  interactiveState,
  containerType
}) => {
  const dispatch = useDispatch();
  const handleEmbed = () => {
    dispatch(openEmbedModal({
      interactiveId
    }));
  };
  const showEmbedAction = getIsPublished(interactiveState) && containerType === CONTAINER_TYPES.EMBEDDED;
  return showEmbedAction ? /*#__PURE__*/_jsx(Button, {
    onClick: handleEmbed,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.embed"
    })
  }) : null;
};
export default EmbedMenuAction;